/**
 * @generated SignedSource<<4caf7f7d6392015a23e863e36f5801f1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDiscoveryBackgroundGalleryQuery$variables = Record<PropertyKey, never>;
export type useDiscoveryBackgroundGalleryQuery$data = {
  readonly imageMacroCategories: ReadonlyArray<{
    readonly hasImages: boolean;
  }>;
  readonly sellerSetting: {
    readonly sellerProperties: {
      readonly hasDefaultBackgroundGallery: boolean;
    } | null;
  };
};
export type useDiscoveryBackgroundGalleryQuery = {
  response: useDiscoveryBackgroundGalleryQuery$data;
  variables: useDiscoveryBackgroundGalleryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProperties",
  "kind": "LinkedField",
  "name": "sellerProperties",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasDefaultBackgroundGallery",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "onlybackground",
    "value": true
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasImages",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDiscoveryBackgroundGalleryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SellerSetting",
        "kind": "LinkedField",
        "name": "sellerSetting",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": "imageMacroCategories(onlybackground:true)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useDiscoveryBackgroundGalleryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SellerSetting",
        "kind": "LinkedField",
        "name": "sellerSetting",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ImageMacroCategory",
        "kind": "LinkedField",
        "name": "imageMacroCategories",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": "imageMacroCategories(onlybackground:true)"
      }
    ]
  },
  "params": {
    "cacheID": "9b99726df2c62366d549a642884dbeb1",
    "id": null,
    "metadata": {},
    "name": "useDiscoveryBackgroundGalleryQuery",
    "operationKind": "query",
    "text": "query useDiscoveryBackgroundGalleryQuery {\n  sellerSetting {\n    sellerProperties {\n      hasDefaultBackgroundGallery\n    }\n    id\n  }\n  imageMacroCategories(onlybackground: true) {\n    hasImages\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6af81e959dc5375dd4cf04f73f277c0e";

export default node;
